// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The switch deliberately targets only the public CarrerUp website. */
body.wb-light-mode .wb-site {
  color: #17344f;
}

body.wb-light-mode .wb-ai-hero,
body.wb-light-mode .wb-command-section,
body.wb-light-mode .wb-protocol-section,
body.wb-light-mode .wb-opportunity-section,
body.wb-light-mode .wb-contact-terminal {
  color: #17344f;
  background: #edf4f8;
}

body.wb-light-mode .wb-ai-grid,
body.wb-light-mode .wb-command-grid,
body.wb-light-mode .wb-protocol-grid { opacity: .32; }
body.wb-light-mode .wb-ai-stars,
body.wb-light-mode .wb-ai-aurora,
body.wb-light-mode .wb-command-orbit,
body.wb-light-mode .wb-opportunity-scan { opacity: .1; }

body.wb-light-mode .wb-ai-description,
body.wb-light-mode .wb-command-lead,
body.wb-light-mode .wb-protocol-heading p,
body.wb-light-mode .wb-opportunity-header p,
body.wb-light-mode .wb-contact-intel > p { color: #527187; }

body.wb-light-mode .wb-ai-core {
  background: #fff;
  border-color: #e0946e;
  box-shadow: 0 0 0 13px rgba(233, 90, 19, .06), 0 0 40px rgba(78, 119, 153, .15);
}
body.wb-light-mode .wb-ai-core-label,
body.wb-light-mode .wb-ai-insight strong { color: #17344f; }
body.wb-light-mode .wb-ai-node,
body.wb-light-mode .wb-ai-insight {
  color: #315978;
  background: #fff;
  border-color: #d3e3ec;
  box-shadow: 0 10px 25px rgba(32, 69, 97, .1);
}

body.wb-light-mode .wb-command-card,
body.wb-light-mode .wb-protocol-step,
body.wb-light-mode .wb-opportunity-card {
  color: #17344f;
  background: #fff;
  border-color: #d4e3ec;
  box-shadow: 0 12px 28px rgba(33, 69, 94, .09);
}
body.wb-light-mode .wb-opportunity-main { background: #f7fbfd; }
body.wb-light-mode .wb-command-card h3,
body.wb-light-mode .wb-protocol-content h3,
body.wb-light-mode .wb-opportunity-card h3 { color: #17344f; }
body.wb-light-mode .wb-command-card p,
body.wb-light-mode .wb-protocol-content p,
body.wb-light-mode .wb-opportunity-card p { color: #58758a; }
body.wb-light-mode .wb-command-status,
body.wb-light-mode .wb-contact-shell {
  background: #fff;
  border-color: #d2e2eb;
  box-shadow: 0 15px 35px rgba(33, 69, 94, .11);
}
body.wb-light-mode .wb-command-status strong { color: #17344f; }

body.wb-light-mode .wb-contact-intel { background: #f7fbfd; border-color: #d2e2eb; }
body.wb-light-mode .wb-contact-panel { background: #fff; }
body.wb-light-mode .wb-contact-panel input,
body.wb-light-mode .wb-contact-panel textarea {
  color: #17344f;
  background: #f8fbfd;
  border-color: #d4e3ec;
}

body.wb-light-mode .wb-footer {
  color: #17344f;
  background: #e5f0f5;
  border-color: #cfdee7;
}
body.wb-light-mode .wb-footer-glow { display: none; }
body.wb-light-mode .wb-footer-brand p,
body.wb-light-mode .wb-footer-column a { color: #527187; }

body.wb-light-mode .wb-wcm-header {
  color: #17344f;
  background: rgba(255, 255, 255, .92);
  border-color: #d4e3eb;
  box-shadow: 0 12px 30px rgba(33, 69, 94, .12);
}
body.wb-light-mode .wb-wcm-header::before { display: none; }
body.wb-light-mode .wb-wcm-nav a { color: #315978; }
body.wb-light-mode .wb-theme-btn,
body.wb-light-mode .language-btn { color: #315978; background: #f5fafc; border-color: #d4e3eb; }

@media (max-width: 1040px) {
  body.wb-light-mode .wb-wcm-nav { background: #fff; }
  body.wb-light-mode .wb-wcm-nav a { color: #17344f; }
}
`, "",{"version":3,"sources":["webpack://./src/mainwebsite/Main/WebsiteTheme.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;uCAEuC,YAAY,EAAE;AACrD;;;0CAG0C,WAAW,EAAE;;AAEvD;;;;2CAI2C,cAAc,EAAE;;AAE3D;EACE,gBAAgB;EAChB,qBAAqB;EACrB,+EAA+E;AACjF;AACA;2CAC2C,cAAc,EAAE;AAC3D;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,0CAA0C,mBAAmB,EAAE;AAC/D;;6CAE6C,cAAc,EAAE;AAC7D;;4CAE4C,cAAc,EAAE;AAC5D;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,+CAA+C,cAAc,EAAE;;AAE/D,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;AACnF,uCAAuC,gBAAgB,EAAE;AACzD;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA,qCAAqC,aAAa,EAAE;AACpD;yCACyC,cAAc,EAAE;;AAEzD;EACE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,4CAA4C,aAAa,EAAE;AAC3D,mCAAmC,cAAc,EAAE;AACnD;mCACmC,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAE/F;EACE,iCAAiC,gBAAgB,EAAE;EACnD,mCAAmC,cAAc,EAAE;AACrD","sourcesContent":["/* The switch deliberately targets only the public CarrerUp website. */\nbody.wb-light-mode .wb-site {\n  color: #17344f;\n}\n\nbody.wb-light-mode .wb-ai-hero,\nbody.wb-light-mode .wb-command-section,\nbody.wb-light-mode .wb-protocol-section,\nbody.wb-light-mode .wb-opportunity-section,\nbody.wb-light-mode .wb-contact-terminal {\n  color: #17344f;\n  background: #edf4f8;\n}\n\nbody.wb-light-mode .wb-ai-grid,\nbody.wb-light-mode .wb-command-grid,\nbody.wb-light-mode .wb-protocol-grid { opacity: .32; }\nbody.wb-light-mode .wb-ai-stars,\nbody.wb-light-mode .wb-ai-aurora,\nbody.wb-light-mode .wb-command-orbit,\nbody.wb-light-mode .wb-opportunity-scan { opacity: .1; }\n\nbody.wb-light-mode .wb-ai-description,\nbody.wb-light-mode .wb-command-lead,\nbody.wb-light-mode .wb-protocol-heading p,\nbody.wb-light-mode .wb-opportunity-header p,\nbody.wb-light-mode .wb-contact-intel > p { color: #527187; }\n\nbody.wb-light-mode .wb-ai-core {\n  background: #fff;\n  border-color: #e0946e;\n  box-shadow: 0 0 0 13px rgba(233, 90, 19, .06), 0 0 40px rgba(78, 119, 153, .15);\n}\nbody.wb-light-mode .wb-ai-core-label,\nbody.wb-light-mode .wb-ai-insight strong { color: #17344f; }\nbody.wb-light-mode .wb-ai-node,\nbody.wb-light-mode .wb-ai-insight {\n  color: #315978;\n  background: #fff;\n  border-color: #d3e3ec;\n  box-shadow: 0 10px 25px rgba(32, 69, 97, .1);\n}\n\nbody.wb-light-mode .wb-command-card,\nbody.wb-light-mode .wb-protocol-step,\nbody.wb-light-mode .wb-opportunity-card {\n  color: #17344f;\n  background: #fff;\n  border-color: #d4e3ec;\n  box-shadow: 0 12px 28px rgba(33, 69, 94, .09);\n}\nbody.wb-light-mode .wb-opportunity-main { background: #f7fbfd; }\nbody.wb-light-mode .wb-command-card h3,\nbody.wb-light-mode .wb-protocol-content h3,\nbody.wb-light-mode .wb-opportunity-card h3 { color: #17344f; }\nbody.wb-light-mode .wb-command-card p,\nbody.wb-light-mode .wb-protocol-content p,\nbody.wb-light-mode .wb-opportunity-card p { color: #58758a; }\nbody.wb-light-mode .wb-command-status,\nbody.wb-light-mode .wb-contact-shell {\n  background: #fff;\n  border-color: #d2e2eb;\n  box-shadow: 0 15px 35px rgba(33, 69, 94, .11);\n}\nbody.wb-light-mode .wb-command-status strong { color: #17344f; }\n\nbody.wb-light-mode .wb-contact-intel { background: #f7fbfd; border-color: #d2e2eb; }\nbody.wb-light-mode .wb-contact-panel { background: #fff; }\nbody.wb-light-mode .wb-contact-panel input,\nbody.wb-light-mode .wb-contact-panel textarea {\n  color: #17344f;\n  background: #f8fbfd;\n  border-color: #d4e3ec;\n}\n\nbody.wb-light-mode .wb-footer {\n  color: #17344f;\n  background: #e5f0f5;\n  border-color: #cfdee7;\n}\nbody.wb-light-mode .wb-footer-glow { display: none; }\nbody.wb-light-mode .wb-footer-brand p,\nbody.wb-light-mode .wb-footer-column a { color: #527187; }\n\nbody.wb-light-mode .wb-wcm-header {\n  color: #17344f;\n  background: rgba(255, 255, 255, .92);\n  border-color: #d4e3eb;\n  box-shadow: 0 12px 30px rgba(33, 69, 94, .12);\n}\nbody.wb-light-mode .wb-wcm-header::before { display: none; }\nbody.wb-light-mode .wb-wcm-nav a { color: #315978; }\nbody.wb-light-mode .wb-theme-btn,\nbody.wb-light-mode .language-btn { color: #315978; background: #f5fafc; border-color: #d4e3eb; }\n\n@media (max-width: 1040px) {\n  body.wb-light-mode .wb-wcm-nav { background: #fff; }\n  body.wb-light-mode .wb-wcm-nav a { color: #17344f; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
